var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cdn-social-bar",class:{
    'cdn-social-bar__variant-floating': _vm.variant === 'floating',
    'cdn-social-bar__variant-inline': _vm.variant === 'inline',
  }},[_c('li',_vm._l((_vm.socials),function({ href, ariaText, iconComponent, type },i){return _c('ul',{key:i,staticClass:"cdn-social-bar__social-list-item",class:[`cdn-social-bar__${type}`]},[_c('a',{staticClass:"cdn-social-bar__social-link",attrs:{"href":href,"aria-label":ariaText,"target":"_blank"}},[_c(iconComponent,{tag:"component"})],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }